:host {
  /**
    * @prop --background-color: Background color of the alert
    * @prop --color: Text color of the alert
    *
    * @prop --padding-top: Padding top of the alert
    * @prop --padding-right: Padding right of the alert
    * @prop --padding-bottom: Padding bottom of the alert
    * @prop --padding-left: Padding left of the alert
    *
    * @prop --font-family: Font family of the alert text
    * @prop --font-size: Font size of the alert text
    * @prop --font-weight: Font weight of the alert text
    */
  -webkit-font-smoothing: antialiased;
  padding: var(--padding-top, 0.5rem) var(--padding-right, 1rem) var(--padding-bottom, 0.5rem) var(--padding-left, 1rem);
  min-height: var(--height, 1.5rem);
  color: var(--color, $alert-info-color);
  background-color: var(--background-color, $light-400);
  border: 0.0625rem solid $neutral-100;
  font-family: var(--font-family, "Work Sans", Helvetica, Arial, sans-serif);
  font-size: var(--font-size, 0.8125rem);
  font-weight: var(--font-weight, normal);
  line-height: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .snackbar {
    &__content {
      display: block;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
    }
    &__content .icon{
      display: flex;
      align-items: center;
    }
    &__content .section{
      display: flex;
      gap: 0.5rem;
    }
    &__content .cta{
      color: $primary;
      
    }
    &__content .cta > a{
      text-decoration: none;
      color: $primary;
      &:hover {
        cursor: pointer;
        color: $orange-300;
      }
    }
    &__close-text {
      cursor: pointer;
      opacity: .5;
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.35rem;
      padding: .55rem 0.8rem;
      text-shadow: 0 0.0625rem 0 $light;
      &:hover {
        opacity: .85;
      }
    }
    &__dismissible {
      padding-right: 1.25rem;
    }
  }
}

:host(.rounded) {
  border-radius: var(--border-radius, 0.5rem);
}
